var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"completeInformation"},[_c('personal-head',{attrs:{"title":"基本信息","hide":true}}),(_vm.userRole === '1' || _vm.userRole === '2')?_c('user-info'):_vm._e(),(_vm.userRole === '3')?_c('test-info'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }